/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';
import { AttachmentVO } from '@well/attachment/domain';
import { AbstractFileStorageService } from '../file-storage/abstract-file-storage.service';

@Component({
  selector: 'well-attachments-view',
  templateUrl: './attachments-view.component.html',
  styleUrls: ['./attachments-view.component.scss']
})
export class AttachmentsViewComponent {

  @Input() attachments: AttachmentVO[] = [];

  constructor(private abstractFileStorageService: AbstractFileStorageService) {
  }

  download(id: string) {
    this.abstractFileStorageService.downloadFileById(id);
  }
}
